import React from "react";
import { getBackendUrl } from "../../utils/env";

export default function RankingShareCard({
    me,
    ranking = [],
}) {
    if (!me || ranking.length === 0) return null;

    const position =
        ranking.findIndex(
            (r) => String(r.id) === String(me.id)
        ) + 1;

    const totalUsers = ranking.length;

    const topThree = ranking.slice(0, 3);

    const podiumOrder = [
        topThree[1]
            ? {
                ...topThree[1],
                place: 2,
                height: 450,
                color: "#C0C0C0",
            }
            : null,

        topThree[0]
            ? {
                ...topThree[0],
                place: 1,
                height: 650,
                color: "#FFD700",
            }
            : null,

        topThree[2]
            ? {
                ...topThree[2],
                place: 3,
                height: 350,
                color: "#CD7F32",
            }
            : null,
    ].filter(Boolean);

    return (
        <div
            id="ranking-share-card"
            style={{
                width: 1080,
                minheight: 1920,
                overflow: "hidden",
                background:
                    "radial-gradient(circle at top, #2a2a2a 0%, #121212 40%, #000000 100%)",
                color: "#fff",
                padding: 80,
                boxSizing: "border-box",
                fontFamily: "Arial, sans-serif",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Header */}

            <div style={{ textAlign: "center" }}>
                <div
                    style={{
                        color: "#ffe000",
                        fontSize: 120,
                        fontWeight: 900,
                        letterSpacing: 4,
                    }}
                >
                    BRAVOS
                </div>

                <div
                    style={{
                        marginTop: 10,
                        fontSize: 56,
                        fontWeight: 700,
                    }}
                >
                    Ranking Semanal
                </div>
            </div>

            {/* Podio */}

            <div
                style={{
                    marginTop: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    gap: 30,
                }}
            >
                {podiumOrder.map((player) => (
                    <div
                        key={player.id}
                        style={{
                            width: 280,
                            textAlign: "center",
                            position: "relative",
                        }}
                    >
                        {player.place === 1 && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: -100,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    fontSize: 80,
                                    zIndex: 10,
                                }}
                            >
                                👑
                            </div>
                        )}

                        {player.profile_picture ? (
                            <img
                                crossOrigin="anonymous"
                                src={`${getBackendUrl()}${player.profile_picture}`}
                                alt={player.name}
                                style={{
                                    width: 180,
                                    height: 180,
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    border: `6px solid ${player.color}`,
                                    marginBottom: 20,
                                    boxShadow: `0 0 40px ${player.color}`,
                                    display: "block",
                                    margin: "0 auto 20px",
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: 150,
                                    height: 150,
                                    borderRadius: "50%",
                                    background: "#222",
                                    border: `6px solid ${player.color}`,
                                    margin: "0 auto 20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: 50,
                                    fontWeight: 700,
                                }}
                            >
                                {player.name?.charAt(0)}
                            </div>
                        )}

                        <div
                            style={{
                                fontSize: 34,
                                fontWeight: 700,
                                marginBottom: 10,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {player.name}
                        </div>

                        <div
                            style={{
                                fontSize: 30,
                                color: player.color,
                                marginBottom: 20,
                                fontWeight: 700,
                            }}
                        >
                            {player.points.toLocaleString()} B
                        </div>

                        <div
                            style={{
                                height: player.height,
                                background: player.color,
                                borderRadius: "30px 30px 0 0",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#000",
                                fontSize: 150,
                                fontWeight: 900,
                            }}
                        >
                            {player.place}
                        </div>
                    </div>
                ))}
            </div>

            {/* Usuario */}

            <div
                style={{
                    marginTop: 60,
                    border: "4px solid #ffe000",
                    borderRadius: 40,
                    background: "rgba(255,255,255,.05)",
                    padding: 60,
                    textAlign: "center",
                    backdropFilter: "blur(10px)",
                }}
            >
                {me.profile_picture ? (
                    <img
                        crossOrigin="anonymous"
                        src={`${getBackendUrl()}${me.profile_picture}`}
                        alt={me.name}
                        style={{
                            width: 180,
                            height: 180,
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "8px solid #ffe000",
                            margin: "0 auto 40px",
                            display: "block",
                            boxShadow:
                                "0 0 50px rgba(255,224,0,.6)",
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: 220,
                            height: 220,
                            borderRadius: "50%",
                            background: "#222",
                            border: "8px solid #ffe000",
                            margin: "0 auto 40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 90,
                            fontWeight: 700,
                        }}
                    >
                        {me.name?.charAt(0)}
                    </div>
                )}

                <div
                    style={{
                        color: "#ffe000",
                        fontSize: 50,
                        fontWeight: 700,
                    }}
                >
                    TU POSICIÓN
                </div>

                <div
                    style={{
                        fontSize: 160,
                        fontWeight: 900,
                        lineHeight: 1,
                        marginTop: 20,
                    }}
                >
                    #{position}
                </div>

                <div
                    style={{
                        fontSize: 60,
                        marginTop: 20,
                        fontWeight: 700,
                    }}
                >
                    {me.name}
                </div>

                <div
                    style={{
                        fontSize: 80,
                        color: "#ffe000",
                        marginTop: 30,
                        fontWeight: 800,
                    }}
                >
                    {me.points.toLocaleString()} B
                </div>

                <div
                    style={{
                        marginTop: 20,
                        fontSize: 36,
                        opacity: 0.85,
                    }}
                >
                    entre {totalUsers} participantes
                </div>
            </div>

            <div
                style={{
                    marginTop: "auto",
                    textAlign: "center",
                    color: "#ffe000",
                    fontSize: 48,
                    fontWeight: 700,
                }}
            >
                🔥 Sigue sumando bravos 🔥
            </div>
        </div>
    );
}